var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"expired-link"}},[_c('img',{staticClass:"nothing-going-on",attrs:{"src":require("@shared/assets/img/general/svg/invite-expired.svg")}})])
}]

export { render, staticRenderFns }